import { CSSProperties } from 'react';

export const styles = (): Record<string, CSSProperties> => ({
  root: {
    height: '100%',
    width: '100%'
  }
});
